// extracted by mini-css-extract-plugin
export var newsBlock = "news-blocks-module--newsBlock--be6ae";
export var newsBlocks = "news-blocks-module--newsBlocks--b4468";
export var newsBlocksTitle = "news-blocks-module--newsBlocksTitle--73138";
export var newsDate = "news-blocks-module--newsDate--00714";
export var newsTitle = "news-blocks-module--newsTitle--eaa63";